import cx from 'classnames';
import React from 'react';
import { TextV2 } from '../../TextV2/TextV2';
import styles from '../PricingTable/PricingTable.module.scss';
import type { IPricingTableDescriptionProps } from '../types';
import { PRICING_TABLE_DESCRIPTION_TEST_ID } from './PricingTableDescription.const';

export const PricingTableDescription: React.FC<IPricingTableDescriptionProps> = ({ bundles }) => {
  return (
    <tr data-testid={PRICING_TABLE_DESCRIPTION_TEST_ID.row}>
      <td className={cx(styles.tableHeadColumnCell, styles.tableButtonCell)} />
      {bundles.map(({ description, id }) => (
        <td key={`description-${id}`} className={cx(styles.tableHeadColumnCell, styles.tableMiddleCell)}>
          <TextV2
            className={styles.tableDescription}
            data-testid={PRICING_TABLE_DESCRIPTION_TEST_ID.description}
            value={description}
            variant="body"
            tagName="p"
          />
        </td>
      ))}
    </tr>
  );
};
